export const autohideTimeout = 3000;
export const disableButtonTimeout = 500;
